import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import outair_handlewarning from '../entities/outair_handlewarning'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface outair_handlewarningState extends ListState<outair_handlewarning>{
    editoutair_handlewarning:outair_handlewarning
}
class UserMutations extends ListMutations<outair_handlewarning>{

}
class Outair_handlewarningModule extends ListModule<outair_handlewarningState,any,outair_handlewarning>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<outair_handlewarning>(),
        filterlist:new Array<outair_handlewarning>(),
        loading:false,
        editoutair_handlewarning:new outair_handlewarning()
    }
    actions={
        async getAll(context:ActionContext<outair_handlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Outair_Handlewarning/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_handlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<outair_handlewarningState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/Outair_Handlewarning/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_handlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<outair_handlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Outair_Handlewarning/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_handlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<outair_handlewarningState,any>,payload:any){
            await Ajax.post('/api/services/app/Outair_Handlewarning/Create',payload.data);
        },
        async uploadimg(context:ActionContext<outair_handlewarningState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<outair_handlewarningState,any>,payload:any){
            await Ajax.put('/api/services/app/Outair_Handlewarning/Update',payload.data);
        },
        async delete(context:ActionContext<outair_handlewarningState,any>,payload:any){
            await Ajax.delete('/api/services/app/Outair_Handlewarning/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<outair_handlewarningState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Outair_Handlewarning/GetById?Id='+payload.id);
            return reponse.data.result as outair_handlewarning;
        }
    };
    mutations={
        setCurrentPage(state:outair_handlewarningState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:outair_handlewarningState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:outair_handlewarningState,outair_handlewarning:outair_handlewarning){
            
            state.editoutair_handlewarning=outair_handlewarning;
            //console.log(state.editFloor);
        }
    }
}
const outair_handlewarningModule=new Outair_handlewarningModule();
export default outair_handlewarningModule;